import React, { useEffect } from "react";
import { getOppMasterMerchants } from "../PaymentProviders/Opp/OppApi";
import OppMasterMerchantButton from "./OppMasterMerchantButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Grid } from "@material-ui/core";
import { withRouter } from "react-router-dom";

function OppInvoices(props) {
  const [oppMasterMerchants, setOppMasterMerchants] = React.useState(null);

  useEffect(() => {
    getOppMasterMerchants().then((oppMasterMerchants) => {
      setOppMasterMerchants(oppMasterMerchants);
    });
  }, []);

  if (oppMasterMerchants == null) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <Grid container spacing={1}>
      {oppMasterMerchants.map((oppMasterMerchant) => {
        return (
          <Grid item xs={6}>
            <OppMasterMerchantButton
              oppMasterMerchant={oppMasterMerchant}
              onClick={() => {
                props.history.push(
                  "/home/" + props.match.params.merchantId + "/opp_master_merchants/" + oppMasterMerchant.id,
                  { oppMasterMerchant: oppMasterMerchant }
                );
              }}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}

OppInvoices.propTypes = {};

export default withRouter(OppInvoices);
